export default __webpack_public_path__ + "static/media/revelution.158ed3cc.png";